import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import client, { videoUrl } from "../lib/api";
import { ArrowLeft, Clock, CheckCircle2, XCircle, RefreshCw } from "lucide-react";

export default function SubmissionStatus() {
    const { id } = useParams();
    const [sub, setSub] = useState(null);

    const load = () => {
        client.get("/submissions/me").then((r) => {
            setSub(r.data.find((s) => s.id === id));
        });
    };

    useEffect(() => {
        load();
        const t = setInterval(load, 6000);
        return () => clearInterval(t);
    }, [id]);

    if (!sub) return <div className="p-6 text-zinc-400">Loading...</div>;

    const cfg = {
        pending: { c: "#F59E0B", icon: Clock, label: "Pending Review", desc: "An admin will review soon." },
        approved: { c: "#39FF14", icon: CheckCircle2, label: "Approved", desc: "Clean reps. XP added." },
        rejected: { c: "#FF2424", icon: XCircle, label: "Rejected", desc: "Read the feedback. Lock in." },
        resubmit: { c: "#FF3B30", icon: RefreshCw, label: "Resubmit Required", desc: "Try again with the notes." },
    }[sub.status] || { c: "#39FF14", icon: Clock, label: sub.status };

    return (
        <div className="px-5 pt-8 pb-12">
            <Link to="/app" className="inline-flex items-center text-zinc-500 hover:text-white" data-testid="ss-back">
                <ArrowLeft size={18} />
                <span className="ml-2 label-cap text-xs">Home</span>
            </Link>

            <div className="mt-8 text-center">
                <div
                    className="w-24 h-24 mx-auto flex items-center justify-center"
                    style={{ background: `${cfg.c}15`, border: `2px solid ${cfg.c}` }}
                >
                    <cfg.icon size={40} style={{ color: cfg.c }} />
                </div>
                <h1 className="font-display font-black text-4xl uppercase mt-6 tracking-tight" style={{ color: cfg.c }}>
                    {cfg.label}
                </h1>
                <p className="text-zinc-400 mt-2">{cfg.desc}</p>
            </div>

            <div className="mt-8 surface-2 p-4">
                <div className="label-cap text-xs text-zinc-500">Challenge</div>
                <div className="font-display font-bold text-xl uppercase mt-1">{sub.challenge_title}</div>
                <div className="text-xs text-zinc-500 mt-2">
                    Submitted {new Date(sub.submitted_at).toLocaleString()}
                </div>
            </div>

            <div className="mt-4 surface-1 overflow-hidden">
                <video
                    src={videoUrl(sub.id)}
                    controls
                    playsInline
                    className="w-full bg-black"
                    style={{ maxHeight: 360 }}
                    data-testid="submission-video"
                />
            </div>

            {sub.notes && (
                <div className="mt-4 surface-1 p-4">
                    <div className="label-cap text-xs text-zinc-500">Your Notes</div>
                    <p className="text-zinc-300 mt-2 text-sm">{sub.notes}</p>
                </div>
            )}

            {sub.feedback && (
                <div className="mt-4 surface-1 p-4 border-l-2" style={{ borderLeftColor: cfg.c }}>
                    <div className="label-cap text-xs" style={{ color: cfg.c }}>
                        Admin Feedback
                    </div>
                    <p className="text-zinc-300 mt-2 text-sm">{sub.feedback}</p>
                </div>
            )}

            <Link
                to={`/app/challenges/${sub.challenge_id}`}
                data-testid="ss-retry"
                className="mt-6 btn-primary w-full py-4 block text-center text-lg"
            >
                {sub.status === "approved" ? "Next Challenge" : "Try Again"}
            </Link>
        </div>
    );
}
